<template>
  <div class="vd-gl-content">
    <a-row class="vd-toolbar">
      <a-col class="vd-toolbar-right vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <a-button type="primary" icon="plus" @click="showSearchTableModal">
              新建数据表格</a-button
            >
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

    <a-table row-key="id" :data-source="list" :pagination="pagination">
      <a-table-column title="ID" data-index="id" />
      <a-table-column title="表名" data-index="name" />
      <a-table-column title="备注" data-index="remark" />
      <a-table-column title="操作">
        <template slot-scope="item">
          <a-tag color="#87d068" @click="toField(item.id)"> 设置字段</a-tag>
          <a-tag color="#87d068" @click="toData(item.id)"> 设置数据</a-tag>
          <!-- <a-tag color="#f50" @click="removeExcel(item.id)">
                移除数据表
              </a-tag> -->
        </template>
      </a-table-column>
    </a-table>

    <a-modal
      title="新建数据表格"
      :visible="searchTableVisible"
      ok-text="确定"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rule"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="表名" prop="name">
          <a-input class="vd-input-s" v-model="form.name" />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input class="vd-input-s" v-model="form.remark" />
        </a-form-model-item>

        <a-form-model-item label="过期时间" prop="due_time">
          <a-date-picker
            :showToday="false"
            v-model="form.due_time"
            placeholder="资料过期时间"
            format="YYYY-MM-DD"
            @change="dateChange"
            :disabled-date="disabledDate"
          >
          </a-date-picker>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { auto_get_table, auto_modify_table } from '@/api/auto'

export default {
  name: 'Table',
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      searchTableVisible: false,
      rule: {
        name: [{ required: true, message: '请输入表名', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        due_time: [
          { required: true, message: '请选择过期时间', trigger: 'blur' },
        ],
      },
      list: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      form: {
        name: undefined,
        remark: undefined,
        due_time: undefined,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      auto_get_table({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        }
      })
    },
    // 去设置字段页面
    toField(id) {
      this.$router.push({ path: '/auto/table/field', query: { id: id } })
    },
    // 去设置数据页面
    toData(id) {
      this.$router.push({ path: '/auto/table/data', query: { id: id } })
    },
    showSearchTableModal() {
      this.searchTableVisible = !this.searchTableVisible
    },
    handleOk() {
      // 输入检测
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          auto_modify_table({
            name: this.form.name,
            remark: this.form.remark,
            due_time: this.form.due_time,
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success('创建成功')
              this.getData()
              this.searchTableVisible = !this.searchTableVisible
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    handleCancel() {
      this.searchTableVisible = !this.searchTableVisible
      this.form.name = this.form.remark = this.form.due_time = undefined
    },
    dateChange(dates) {
      this.form.due_time = dates
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf('day')
    },
    removeExcel(id) {
      console.log(id)
    },
  },
}
</script>

<style scoped></style>
